<template>
    <div class="container-fluid userGroupManagementTagsWrapper">
        <!-- 会員 -->
        <div class="table-wrapper">
            <div class="d-block d-lg-flex justify-content-between align-items-center mb-3">
                <div class="table-name mb-2 mb-lg-0">管理用タグ（会員）</div>
                <div class="d-flex flex-wrap align-items-center">
                    <div class="mr-3">
                        <div class="input-group input-group-sm">
                            <input
                                v-model="user_search.freeword"
                                @blur="onChangeUserSearchFreeword"
                                type="text"
                                class="form-control inputFreeword"
                                placeholder="フリーワード">
                            <div class="input-group-append">
                                <div
                                    class="input-group-text"
                                    @click="onChangeUserSearchFreeword">
                                    検索
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="add-button-wrapper">
                        <b-button
                            variant="yokumiru-orange"
                            @click="showModalUserAuthorizerManagementTagsStore"
                            :disabled="inProgress">
                            追加
                        </b-button>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-md-12">
                    <b-table
                        striped
                        hover
                        responsive
                        :items="user_management_tags"
                        :fields="fields"
                        :sort-by.sync="userMorphState.sortBy"
                        :sort-desc.sync="userMorphState.sortDesc"
                        @sort-changed="fetchUserManagementTags"
                        class="table-bordered m-table">

                        <template v-slot:cell(created_at)="data">
                            <span class="u-palt">
                                {{ helper.dateTimeForHuman(data.item.created_at, timezoneAsia) }}
                            </span>
                        </template>

                        <template v-slot:cell(links)="data">
                            <div class="text-center">
                                <div>
                                    <b-button
                                        class="btn btn-yokumiru-blue btn-sm m-2"
                                        @click="showModalUserAuthorizerManagementTagsEdit(data.item)">
                                        編集
                                    </b-button>
                                    <b-button
                                        size="sm"
                                        variant="danger"
                                        @click="showModalUserAuthorizerManagementTagsDelete(data.item)">
                                        削除
                                    </b-button>
                                </div>
                            </div>
                        </template>
                    </b-table>

                    <div class="d-flex flex-wrap justify-content-between align-items-center">
                        <b-pagination
                            :total-rows="userMorphState.total"
                            :per-page="userMorphState.per_page"
                            v-model="userMorphState.current_page"
                            @change="fetchUserManagementTags">
                        </b-pagination>

                        <div class="d-flex flex-wrap align-items-center">
                            <div class="mr-3 mb-3">
                                <span class="small">{{ dispUserPaginationDetail }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <authorizer-user-management-tags-store-modal
                :group="group">
            </authorizer-user-management-tags-store-modal>
            <authorizer-user-management-tags-edit-modal
                :group="group">
            </authorizer-user-management-tags-edit-modal>
            <authorizer-user-management-tags-delete-modal
                :group="group">
            </authorizer-user-management-tags-delete-modal>
        </div>
        <!-- 会員End -->
        
        <!-- 法人 -->
        <div class="table-wrapper">
            <div class="d-block d-lg-flex justify-content-between align-items-center mb-3">
                <div class="table-name mb-2 mb-lg-0">管理用タグ（法人）</div>
                <div class="d-flex flex-wrap align-items-center">
                    <div class="mr-3">
                        <div class="input-group input-group-sm">
                            <input
                                v-model="search.freeword"
                                @blur="onChangeSearchFreeword"
                                type="text"
                                class="form-control inputFreeword"
                                placeholder="フリーワード">
                            <div class="input-group-append">
                                <div
                                    class="input-group-text"
                                    @click="onChangeSearchFreeword">
                                    検索
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="add-button-wrapper">
                        <b-button
                            variant="yokumiru-orange"
                            @click="showModalAuthorizerManagementTagsStore"
                            :disabled="inProgress">
                            追加
                        </b-button>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-md-12">
                    <b-table
                        striped
                        hover
                        responsive
                        :items="group_management_tags"
                        :fields="fields"
                        :sort-by.sync="morphState.sortBy"
                        :sort-desc.sync="morphState.sortDesc"
                        @sort-changed="fetchManagementTags"
                        class="table-bordered m-table">

                        <template v-slot:cell(created_at)="data">
                            <span class="u-palt">
                                {{ helper.dateTimeForHuman(data.item.created_at, timezoneAsia) }}
                            </span>
                        </template>

                        <template v-slot:cell(links)="data">
                            <div class="text-center">
                                <div>
                                    <b-button
                                        class="btn btn-yokumiru-blue btn-sm m-2"
                                        @click="showModalAuthorizerManagementTagsEdit(data.item)">
                                        編集
                                    </b-button>
                                    <b-button
                                        size="sm"
                                        variant="danger"
                                        @click="showModalAuthorizerManagementTagsDelete(data.item)">
                                        削除
                                    </b-button>
                                </div>
                            </div>
                        </template>
                    </b-table>

                    <div class="d-flex flex-wrap justify-content-between align-items-center">
                        <b-pagination
                            :total-rows="morphState.total"
                            :per-page="morphState.per_page"
                            v-model="morphState.current_page"
                            @change="fetchManagementTags">
                        </b-pagination>

                        <div class="d-flex flex-wrap align-items-center">
                            <div class="mr-3 mb-3">
                                <span class="small">{{ dispPaginationDetail }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <authorizer-group-management-tags-store-modal
                :group="group">
            </authorizer-group-management-tags-store-modal>
            <authorizer-group-management-tags-edit-modal
                :group="group">
            </authorizer-group-management-tags-edit-modal>
            <authorizer-group-management-tags-delete-modal
                :group="group">
            </authorizer-group-management-tags-delete-modal>
        </div>
        <!-- 法人End -->

    </div>

    
</template>

<script>
import { mapMutations } from 'vuex'
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'

export default {
    props: {
        timezone: {
            type: String,
            default: 'Asia/Tokyo',
        },
        group: {
            type: Object,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            search: {
                freeword: '',
            },
            user_search: {
                freeword: '',
            },
            group_management_tags: {},
            user_management_tags: {},
            inProgress: false,
            errors: {},
            fields: [
                {
                    key: 'id',
                    label: '#',
                    sortable: true,
                    thClass: 'tableId',
                },
                {
                    key: 'name',
                    label: '名前',
                    sortable: true,
                    thClass: 'tableName',
                },
                {
                    key: 'created_at',
                    label: '作成日時',
                    sortable: true,
                    thClass: 'tableCreated',
                },
                {
                    key: 'links',
                    label: '',
                    sortable: false,
                    thClass: 'tableLinks',
                },
            ],
        }
    },

    computed: {
        timezoneAsia: function () {
            return 'Asia/Tokyo'
        },

        isCompany: function () {
            return this.helper.isCompany(this.group)
        },

        isOrganization: function () {
            return this.helper.isOrganization(this.group)
        },

        morphState: function () {
            if (this.isOrganization) {
                return this.$store.state.userOrganizationGroupManagementTags
            }
            return null
        },

        userMorphState: function () {
            if (this.isOrganization) {
                return this.$store.state.userOrganizationUserManagementTags
            }
            return null
        },

        /**
         * ページング詳細表示
         * @returns {string}
         */
        dispPaginationDetail: function () {
            if (this.morphState.total < 1) return ''
            return `全${this.morphState.total}件中 ${this.morphState.from}～${this.morphState.to}件表示`
        },

        dispUserPaginationDetail: function () {
            console.log("user userMorphState.total", this.userMorphState.total);
            if (this.userMorphState.total < 1) return ''
            return `全${this.userMorphState.total}件中 ${this.userMorphState.from}～${this.userMorphState.to}件表示`
        },

        groupTypeModel: function () {
            if (!this.group) return ''
            return this.helper.groupTypeModel(this.group.group_type)
        },
    },

    created: function () {
        this.childGroups = this.group.child_groups

        this.initQueryFromState()
        this.initSearchCondition()
        this.fetchManagementTags()
        this.fetchUserManagementTags()

        bus.$on('group-management-tags-store', this.fetchManagementTags)
        bus.$on('group-management-tags-edit', this.fetchManagementTags)
        bus.$on('group-management-tags-delete', this.fetchManagementTags)
        bus.$on('user-management-tags-store', this.fetchUserManagementTags)
        bus.$on('user-management-tags-edit', this.fetchUserManagementTags)
        bus.$on('user-management-tags-delete', this.fetchUserManagementTags)
    },

    beforeDestroy: function () {
        bus.$off('group-management-tags-store')
        bus.$off('group-management-tags-edit')
        bus.$off('group-management-tags-delete')
        bus.$off('user-management-tags-store')
        bus.$off('user-management-tags-edit')
        bus.$off('user-management-tags-delete')
    },

    methods: {
        ...mapMutations({            
            setQueryOrganization: 'userOrganizationGroupManagementTags/setQuery',
            setQueriesOrganization: 'userOrganizationGroupManagementTags/setQueries',
            clearQueriesOrganization: 'userOrganizationGroupManagementTags/clearQueries',
            setUserQueryOrganization: 'userOrganizationUserManagementTags/setQuery',
            setUserQueriesOrganization: 'userOrganizationUserManagementTags/setQueries',
            clearUserQueriesOrganization: 'userOrganizationUserManagementTags/clearQueries',
        }),

        setQuery: function (data) {
            if (this.isOrganization) {
                this.setQueryOrganization(data)
            }
            else if (this.isCompany) {
                this.setQueryCompany(data)
            }
        },

        setQueries: function (data) {
            if (this.isOrganization) {
                this.setQueriesOrganization(data)
            }
            else if (this.isCompany) {
                this.setQueriesCompany(data)
            }
        },

        clearQueries: function () {
            if (this.isOrganization) {
                this.clearQueriesOrganization()
            }
            else if (this.isCompany) {
                this.clearQueriesCompany()
            }
        },

        setUserQuery: function (data) {
            if (this.isOrganization) {
                this.setUserQueryOrganization(data)
            }
            else if (this.isCompany) {
                this.setQueryCompany(data)
            }
        },

        setUserQueries: function (data) {
            if (this.isOrganization) {
                this.setUserQueriesOrganization(data)
            }
            else if (this.isCompany) {
                this.setQueriesCompany(data)
            }
        },

        clearUserQueries: function () {
            if (this.isOrganization) {
                this.clearUserQueriesOrganization()
            }
            else if (this.isCompany) {
                this.clearQueriesCompany()
            }
        },

        /**
         * 検索条件の初期化
         */
        initQueryFromState: function () {
            if (localStorage.getItem('yokumiruWeb')) {
                const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                if (this.isOrganization && data.userOrganizationGroupManagementTags) {
                    this.setQueries(data.userOrganizationGroupManagementTags)
                }
                if (this.isOrganization && data.userOrganizationUserManagementTags) {
                    this.setUserQueries(data.userOrganizationUserManagementTags)
                }
            }
        },

        /**
         * 検索条件の初期化
         */
        initSearchCondition: async function () {
            this.search.freeword = this.morphState.freeword
            this.user_search.freeword = this.userMorphState.freeword
        },

        onChangeSearchFreeword: async function () {
            await this.setQuery({ key: 'freeword', value: this.search.freeword })
            await this.fetchManagementTags(1)
        },
        onChangeUserSearchFreeword: async function () {
            await this.setUserQuery({ key: 'freeword', value: this.user_search.freeword })
            await this.fetchUserManagementTags(1)
        },

        /**
         * 法人管理用タグ一覧取得
         *
         * @param {number|object} param
         */
        fetchManagementTags: async function (param = null) {
            if (this.inProgress) return
            this.inProgress = true

            this.group_management_tags = null

            if (Number.isInteger(param) && param > 0) {
                await this.setQuery({ key: 'current_page', value: param })
            }
            else if (param !== null && param.hasOwnProperty('sortBy')) {
                await this.setQuery({ key: 'sortBy', value: param.sortBy })
                await this.setQuery({ key: 'sortDesc', value: param.sortDesc })
            }

            const endpoint = constants.user.groups.endpoint.base

            // 取得 hogeで検索
            //   axios.get(`${endpoint}/${this.group.id}/groups/tags?page=1&freeword=hoge`)

            axios.get(`${endpoint}/${this.group.id}/groups/tags${this.buildQuery()}`)
            .then((data) => {
                this.group_management_tags = data.data.data
                this.inProgress = false
                if (data.data.data.length === 0 && data.data.meta.current_page > 1) {
                    this.setQueries({
                        ...data.data.meta,
                        current_page: data.data.meta.current_page - 1,
                    })
                    return this.fetchManagementTags()
                } else {
                    this.setQueries(data.data.meta)
                }                
            })
            .catch(({response}) => {
                this.inProgress = false
                if (response.status === 422) {
                    this.clearQueries()
                }
            })

            // 作成
            // axios.post(`${endpoint}/${this.group.id}/users/tags`, {
            //     name: 'hoge',
            // })
            // .then(() => {
            //     console.log("aaa")
            // })
            // .catch((e) => {
            //     console.error(e)
            // })

            // 更新
            // axios.put(`${endpoint}/${this.group.id}/users/tags/2`, {
            //     name: 'hoge1',
            // })
            // .then(() => {
            //     console.log("aaa")
            // })
            // .catch((e) => {
            //     console.error(e)
            // })

            // 削除
            // axios.delete(`${endpoint}/${this.group.id}/users/tags/2`)
            // .then(() => {
            //   console.log("aaa")
            // })
            // .catch((e) => {
            //   console.error(e)
            // })

            this.inProgress = false
        },

        /**
         * 会員管理用タグ一覧取得
         *
         * @param {number|object} param
         */
         fetchUserManagementTags: async function (param = null) {
            if (this.inProgress) return
            this.inProgress = true

            this.user_management_tags = null

            if (Number.isInteger(param) && param > 0) {
                await this.setUserQuery({ key: 'current_page', value: param })
            }
            else if (param !== null && param.hasOwnProperty('sortBy')) {
                await this.setUserQuery({ key: 'sortBy', value: param.sortBy })
                await this.setUserQuery({ key: 'sortDesc', value: param.sortDesc })
            }

            const endpoint = constants.user.groups.endpoint.base

            // 取得 hogeで検索
            //   axios.get(`${endpoint}/${this.group.id}/groups/tags?page=1&freeword=hoge`)

          // 会員用
          // axios.get(`${endpoint}/${this.group.id}/users/tags${this.buildQuery()}`)

            axios.get(`${endpoint}/${this.group.id}/users/tags${this.buildUserQuery()}`)
            .then((data) => {
                this.user_management_tags = data.data.data
                this.inProgress = false
                if (data.data.data.length === 0 && data.data.meta.current_page > 1) {
                    this.setUserQueries({
                        ...data.data.meta,
                        current_page: data.data.meta.current_page - 1,
                    })
                    return this.fetchUserManagementTags()
                } else {
                    this.setUserQueries(data.data.meta)
                }                
            })
            .catch(({response}) => {
                this.inProgress = false
                if (response.status === 422) {
                    this.clearUserQueries()
                }
            })

            // 作成
            // axios.post(`${endpoint}/${this.group.id}/users/tags`, {
            //     name: 'hoge',
            // })
            // .then(() => {
            //     console.log("aaa")
            // })
            // .catch((e) => {
            //     console.error(e)
            // })

            // 更新
            // axios.put(`${endpoint}/${this.group.id}/users/tags/2`, {
            //     name: 'hoge1',
            // })
            // .then(() => {
            //     console.log("aaa")
            // })
            // .catch((e) => {
            //     console.error(e)
            // })

            // 削除
            // axios.delete(`${endpoint}/${this.group.id}/users/tags/2`)
            // .then(() => {
            //   console.log("aaa")
            // })
            // .catch((e) => {
            //   console.error(e)
            // })

            this.inProgress = false
        },

        /**
         * QueryString生成
         *
         * @param {boolean} paginate
         * @return {string}
         */
        buildQuery: function (paginate = true) {
            let query = '?'

            const state = this.morphState
            console.log("state", state)

            if (paginate) {
                query += `page=${state.current_page}`
                query += `&sort=${state.sortBy}`
                query += `&desc=${state.sortDesc}`
            }
            else {
                query += `sort=${state.sortBy}`
                query += `&desc=${state.sortDesc}`
            }

            if (state.freeword) {
                query += `&freeword=${state.freeword}`
            }

            return query
        },

        buildUserQuery: function (paginate = true) {
            let query = '?'

            const state = this.userMorphState

            if (paginate) {
                query += `page=${state.current_page}`
                query += `&sort=${state.sortBy}`
                query += `&desc=${state.sortDesc}`
            }
            else {
                query += `sort=${state.sortBy}`
                query += `&desc=${state.sortDesc}`
            }

            if (state.freeword) {
                query += `&freeword=${state.freeword}`
            }

            return query
        },

        showModalAuthorizerManagementTagsStore: function () {
            bus.$emit('open-modal-authorizer-management-tags-store')
        },

        showModalAuthorizerManagementTagsEdit: function ( tag ) {
            bus.$emit('open-modal-authorizer-management-tags-edit', tag)
        },

        showModalAuthorizerManagementTagsDelete: function ( tag ) {
            bus.$emit('open-modal-authorizer-management-tags-delete', tag)
        },

        showModalUserAuthorizerManagementTagsStore: function () {
            bus.$emit('open-modal-authorizer-user-management-tags-store')
        },

        showModalUserAuthorizerManagementTagsEdit: function ( tag ) {
            bus.$emit('open-modal-authorizer-user-management-tags-edit', tag)
        },

        showModalUserAuthorizerManagementTagsDelete: function ( tag ) {
            bus.$emit('open-modal-authorizer-user-management-tags-delete', tag)
        }
    },
}
</script>

<style lang="scss" scoped>
.btnCancel {
    margin-top: 4px;
    min-width: 94px;
}

.inputSearchStatus {
    max-width: 140px;

    @media screen and (max-width:991px) {
        max-width: 100%;
    }
}

.repeatReservedLabel {
    position: relative;
    top: -1px;
    display: inline-block;
    width: 18px;
    height: 18px;
    line-height: 18px;
    color: #fff;
    font-size: 10px;
    text-align: center;
    background-color: #e7a222;
    border-radius: 50%;
}

.table-wrapper {
    width: 100%;

    @media screen and (max-width: 1080px) {
        &:last-child {
            margin-top: 20px;
        }
    }
}

.table-name {
    margin-top: 2px;
    color: #333;
    font-size: 18px;
    font-weight: bold;
    align-items: center;
}

.add-button-wrapper{
    margin-right: 0;
    margin-left: auto;
}

.inputFreeword {
    max-width: 200px;
}
</style>

<style lang="scss">
.userGroupManagementTagsWrapper {
    gap: 35px;
    display: flex;
    justify-content: center;

    @media screen and (max-width: 1080px) {
        display: block;
    }

    table {
        th, td {
            font-size: 0.75rem;
        }
        .tableId{
            width: 10%;
        }
        .tableName{
            width: 40%;
        }
        .tableCreate{
            width: 25%;
        }
        .tableLinks{
            width: 25%;
        }
    }
}
</style>
